function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import { Row, Col, Grid } from 'antd';
import Typography from "../typography";
import Status from "../status-box";
import { ArrowDownOutlined, ArrowUpOutlined } from 'iglooicon';
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var useBreakpoint = Grid.useBreakpoint;
var DetailPanel = function DetailPanel(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    icon = _ref.icon,
    status = _ref.status,
    children = _ref.children;
  var _useBreakpoint = useBreakpoint(),
    md = _useBreakpoint.md;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var needSubContent = subTitle || icon || status;
  if (!md) {
    return /*#__PURE__*/_jsxs("div", {
      className: "igloo-detail-panel-mobile",
      children: [/*#__PURE__*/_jsxs("div", {
        onClick: function onClick() {
          setVisible(function (visible) {
            return !visible;
          });
        },
        className: "igloo-detail-panel-title",
        children: [/*#__PURE__*/_jsx(Typography, {
          level: "body1",
          children: title
        }), /*#__PURE__*/_jsx(ArrowDownOutlined, {
          style: {
            opacity: visible ? 1 : 0
          },
          className: "igloo-detail-panel-arrow"
        }), /*#__PURE__*/_jsx(ArrowUpOutlined, {
          style: {
            opacity: visible ? 0 : 1
          },
          className: "igloo-detail-panel-arrow"
        })]
      }), visible && /*#__PURE__*/_jsxs("div", {
        className: "igloo-detail-panel-content",
        children: [needSubContent && /*#__PURE__*/_jsxs("div", {
          className: "igloo-detail-panel-sub-title",
          children: [icon && /*#__PURE__*/_jsx("div", {
            className: "sub-title-icon",
            children: icon
          }), /*#__PURE__*/_jsxs("div", {
            className: "sub-title-content",
            children: [subTitle && /*#__PURE__*/_jsx(Typography, {
              level: "h4",
              className: "sub-title-title",
              children: subTitle
            }), status && /*#__PURE__*/_jsx("div", {
              className: "sub-title-status",
              children: /*#__PURE__*/_jsx(Status, _objectSpread({}, status))
            })]
          })]
        }), children]
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "igloo-detail-panel",
    children: [/*#__PURE__*/_jsx(Typography, {
      level: "h3b",
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: "igloo-detail-panel-content",
      children: [needSubContent && /*#__PURE__*/_jsxs("div", {
        className: "igloo-detail-panel-sub-title",
        children: [icon && /*#__PURE__*/_jsx("div", {
          className: "sub-title-icon",
          children: icon
        }), /*#__PURE__*/_jsxs("div", {
          className: "sub-title-content",
          children: [subTitle && /*#__PURE__*/_jsx(Typography, {
            level: "h4",
            className: "sub-title-title",
            children: subTitle
          }), status && /*#__PURE__*/_jsx("div", {
            className: "sub-title-status",
            children: /*#__PURE__*/_jsx(Status, _objectSpread({}, status))
          })]
        })]
      }), children]
    })]
  });
};
DetailPanel.DetailItem = function (_ref2) {
  var title = _ref2.title,
    value = _ref2.value;
  return /*#__PURE__*/_jsxs(Row, {
    className: "igloo-detail-panel-item",
    gutter: [4, 4],
    children: [/*#__PURE__*/_jsx(Col, {
      span: 24,
      children: /*#__PURE__*/_jsx(Typography, {
        level: "body1",
        className: "igloo-detail-panel-item-title",
        children: title
      })
    }), /*#__PURE__*/_jsx(Col, {
      span: 24,
      children: /*#__PURE__*/_jsx(Typography, {
        level: "body1",
        className: "igloo-detail-panel-item-value",
        children: value
      })
    })]
  });
};
export default DetailPanel;